import type * as React from 'react';
import { useSelector } from 'react-redux';

import { HousesFilter } from '../../components/HousesFilter';
import { housesDesktopSelector } from '../../selectors/newbuilding';

interface IHousesFilterContainerProps {
  selectedHouseId?: number;
  onClick(houseId?: number): void;
}

export function HousesFilterContainer({
  selectedHouseId,
  onClick,
}: IHousesFilterContainerProps): React.JSX.Element | null {
  const houses = useSelector(housesDesktopSelector);

  if (!houses || houses.length < 2) {
    return null;
  }

  return <HousesFilter selectedHouseId={selectedHouseId} houses={houses} onHouseClick={onClick} />;
}
